 <template>
  <div>
    <el-dialog
      title="รายละเอียดรายการส่งเสริมการขาย"
      :visible.sync="show"
      :label-position="labelPosition"
      :before-close="handleClose"
    >
      <el-form>
        <table>
          <tr>
            <td colspan="2">รายละเอียดข้อมูลบล็อกเชน</td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              Transaction Hash :
            </td>
            <td v-bind:style="styleOption">
              {{rowInfo.transaction_code}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              Block :
            </td>
            <td v-bind:style="styleOption">
              {{rowInfo.block_number}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              From :
            </td>
            <td v-bind:style="styleOption">
              {{rowInfo.from_address}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              To :
            </td>
            <td v-bind:style="styleOption">
              {{rowInfo.to_address}}
            </td>
          </tr>
          <tr>
            <td v-bind:style="styleOption">
              Timestamp :
            </td>
            <td v-bind:style="styleOption">
              {{rowInfo.created_at}}
            </td>
          </tr>
        </table>
        <template v-if="service_type == 'mobile'">
          <table>
            <tr>
              <td colspan="2">รายละเอียดเบื้องต้น</td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                รหัสรายการส่งเสริมการขาย :
              </td>
              <td v-bind:style="styleOption">
                {{info.promotion_code}}
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                ชื่อรายการส่งเสริมการขาย :
              </td>
              <td v-bind:style="styleOption">
                {{info.promotion_name_th}}
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                ประเภทบริการของรายการส่งเสริมการขาย :
              </td>
              <td v-bind:style="styleOption">
                {{info.promotion_category == 'postpaid' ? 'รายเดือน' : 'เติมเงิน'}}
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                ชนิดของรายการส่งเสริมการขาย :
              </td>
              <td v-bind:style="styleOption">
                {{info.promotion_type === 'main' ? 'รายการส่งเสริมการขายหลัก':'รายการส่งเสริมการขายเสริม'}}
              </td>
            </tr>
            <tr>
              <td colspan="2">ระยะเวลา</td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                วันเริ่มต้นการเสนอขาย: 
              </td>
              <td v-bind:style="styleOption">
                {{info.start_sale_date != null ? moment(info.start_sale_date).add(543, 'Y').format('DD-MM-YYYY') : '-'}}
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                วันสิ้นสุดการเสนอขาย:
              </td>
              <td v-bind:style="styleOption">
                {{info.end_sale_date != null ? moment(info.end_sale_date).add(543, 'Y').format('DD-MM-YYYY') : '-'}}
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                วันเริ่มต้นการให้บริการ:
              </td>
              <td v-bind:style="styleOption">
                {{info.start_service_date != null ? moment(info.start_service_date).add(543, 'Y').format('DD-MM-YYYY') : '-'}}
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                วันสิ้นสุดการให้บริการ: <br/>
              </td>
              <td v-bind:style="styleOption">
                {{info.end_service_date != null ? moment(info.end_service_date).add(543, 'Y').format('DD-MM-YYYY') : '-'}} <br/>
              </td>
            </tr>
            <tr> 
              <td v-bind:style="styleOption">
                ค่าบริการเหมาจ่ายรวมตามสิทธิการใช้งาน :
              </td>
              <td v-bind:style="styleOption">
                {{info.promotion_price ? info.promotion_price + ' บาท' : '-'}}
              </td>
            </tr>
            <tr>
              <td colspan="2">ค่าบริการจำแนกตามประเภทบริการ</td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                บริการเสียง :
              </td>
              <td v-bind:style="styleOption">
                {{info.mcsf_voice_service ? info.mcsf_voice_service + ' บาท' : '-'}}
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                บริการ SMS :
              </td>
              <td v-bind:style="styleOption">
                {{info.mcsf_sms_service ? info.mcsf_sms_service + ' บาท' : '-'}}
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                บริการ MMS :
              </td>
              <td v-bind:style="styleOption">
                {{info.mcsf_mms_service ? info.mcsf_mms_service + ' บาท' : '-'}}
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                บริการอินเทอร์เน็ต :
              </td>
              <td v-bind:style="styleOption">
                {{info.mcsf_internet_service ? info.mcsf_internet_service + ' บาท' : '-'}}
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                WiFi :
              </td>
              <td v-bind:style="styleOption">
                {{info.mcsf_wifi_service ? info.mcsf_wifi_service + ' บาท' : '-'}}
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                อื่นๆ :
              </td>
              <td v-bind:style="styleOption">
                {{info.mcsf_other_service ? info.mcsf_other_service + ' บาท' : '-'}}
              </td>
            </tr>
            <tr>
              <td colspan="2">สิทธิการใช้งานที่ผู้ใช้บริการได้รับจำแนกตามประเภทบริการ</td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                บริการเสียง :
              </td>
              <td v-bind:style="styleOption">
                {{info.mcu_voice_minute ? info.mcu_voice_minute + ' นาที' : info.mcu_voice_second ? info.mcu_voice_second + ' วินาที' : '-'}}
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                บริการ SMS :
              </td>
              <td v-bind:style="styleOption">
                {{info.mcu_sms_amount ? info.mcu_sms_amount + ' ข้อความ' : '-'}}
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                บริการ MMS :
              </td>
              <td v-bind:style="styleOption">
                {{info.mcu_mms_amount ? info.mcu_mms_amount + ' ข้อความ' : '-'}}
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                บริการอินเทอร์เน็ต :
              </td>
              <td v-bind:style="styleOption">
                {{info.mcu_internet_MB ? info.mcu_internet_MB + ' MB' : info.mcu_internet_GB ? info.mcu_internet_GB + ' GB' : '-'}}
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                ความเร็วอินเทอร์เน็ต :
              </td>
              <td v-bind:style="styleOption">
                {{info.mcu_internet_speed_Kbps ? info.mcu_internet_speed_Kbps + ' Kbps' : info.mcu_internet_speed_Mbps ? info.mcu_internet_speed_Mbps + ' Mbps' : '-'}}
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                WiFi :
              </td>
              <td v-bind:style="styleOption">
                {{info.mcu_wifi_service_th ? info.mcu_wifi_service_th : '-'}}
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                อื่นๆ :
              </td>
              <td v-bind:style="styleOption">
                {{info.mcu_other_service_th ? info.mcu_other_service_th : '-'}}
              </td>
            </tr>
            <tr>
              <td colspan="2">อัตราค่าบริการเฉลี่ย</td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                ค่าบริการเสียง :
              </td>
              <td v-bind:style="styleOption">
                {{info.masr_voice_per_minute ? Math.round(info.masr_voice_per_minute * 1000)/1000 + ' บาท/นาที' : info.masr_voice_per_second ? info.masr_voice_per_second + ' บาท/วินาที' : '-'}}
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                ค่าบริการ SMS :
              </td>
              <td v-bind:style="styleOption">
                {{info.masr_sms_per_message ? info.masr_sms_per_message + ' บาท/ข้อความ' : '-'}}
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                ค่าบริการ MMS :
              </td>
              <td v-bind:style="styleOption">
                {{info.masr_mms_per_message ? info.masr_mms_per_message + ' บาท/ข้อความ' : '-'}}
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                ค่าบริการอินเทอร์เน็ต :
              </td>
              <td v-bind:style="styleOption">
                {{info.masr_internet_per_MB ? info.masr_internet_per_MB + ' บาท/MB' : '-'}}
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                WiFi :
              </td>
              <td v-bind:style="styleOption">
                {{info.wifi_average ? info.wifi_average : '-'}}
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                อื่นๆ :
              </td>
              <td v-bind:style="styleOption">
                {{info.masr_other_average ? info.masr_other_average : '-'}}
              </td>
            </tr>
            <tr>
              <td colspan="2">อัตราค่าบริการต่อหน่วยในส่วนที่เกินกว่าสิทธิการใช้งานของรายการส่งเสริมการขาย</td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                บริการเสียง(นาทีใดๆ สูงสุด) :
              </td>
              <td v-bind:style="styleOption">
                {{info.mscpu_average_voice_service ? Math.round(info.mscpu_average_voice_service * 100)/100 + ' บาท/นาที' : '-'}}
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                บริการ SMS :
              </td>
              <td v-bind:style="styleOption">
                {{info.mscpu_average_sms_service ? info.mscpu_average_sms_service + ' บาท/ข้อความ' : '-'}}
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                บริการ MMS :
              </td>
              <td v-bind:style="styleOption">
                {{info.mscpu_average_mms_service ? info.mscpu_average_mms_service + ' บาท/ข้อความ' : '-'}}
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                บริการอินเทอร์เน็ต :
              </td>
              <td v-bind:style="styleOption">
                {{info.mscpu_average_internet_service ? info.mscpu_average_internet_service + ' บาท/MB' : '-'}}
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                รูปแบบการคิดค่าบริการประเภทเสียง :
              </td>
              <td v-bind:style="styleOption">
                {{info.service_charge_type == 'minute' ? 'นาที' : info.service_charge_type == 'วินาที' ? 'วินาที' : '-' }}
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                เงื่อนไขอื่นๆ / ข้อกำหนด ของการใช้บริการ :
              </td>
              <td v-bind:style="styleOption">
                {{info.promotion_condition_th ? info.promotion_condition_th : '-'}}
              </td>
            </tr>
            <tr>
              <td colspan="2">
                สิทธิพิเศษ
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                ให้บริการความบันเทิง :
              </td>
              <td v-bind:style="styleOption">
                {{info.privilege_content_th ? info.privilege_content_th : '-'}}
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                ให้บริการโซเชียลมีเดีย :
              </td>
              <td v-bind:style="styleOption">
                {{info.privilege_social_th ? info.privilege_social_th : '-'}}
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                ให้บริการเกม :
              </td>
              <td v-bind:style="styleOption">
                {{info.privilege_game_th ? info.privilege_game_th : '-'}}
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                พรีเมียม :
              </td>
              <td v-bind:style="styleOption">
                {{info.privilege_premium_th ? info.privilege_premium_th : '-'}}
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                อุปกรณ์อื่นๆ :
              </td>
              <td v-bind:style="styleOption">
                {{info.privilege_device_th ? info.privilege_device_th : '-'}}
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                ให้บริการอื่นๆ :
              </td>
              <td v-bind:style="styleOption">
                {{info.privilege_other_th ? info.privilege_other_th : '-'}}
              </td>
            </tr>
            <tr></tr>
            <tr>
              <td v-bind:style="styleOption">
                ลิงก์เว็บไซต์ หรือ ลิงก์รายการส่งเสริมการขาย :
              </td>
              <td v-bind:style="styleOption">
                {{info.promotion_link_url ? info.promotion_link_url : '-'}}
              </td>
            </tr>
          </table>
        </template>
        <template v-if="service_type == 'broadband'">
          <table>
            <tr>
              <td colspan="2">รายละเอียดเบื้องต้น</td>
            </tr>
             <tr>
              <td v-bind:style="styleOption">
                รหัสรายการส่งเสริมการขาย :
              </td>
              <td v-bind:style="styleOption">
                {{info.promotion_code}}
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                ชื่อรายการส่งเสริมการขาย : 
              </td>
              <td v-bind:style="styleOption">
                {{ info.promotion_name_th }}
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                ประเภทเทคโนโลยีของการให้บริการ : 
              </td>
              <td v-bind:style="styleOption">
                {{ info.promotion_technology }}
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                ชนิดของรายการส่งเสริมการขาย : 
              </td>
              <td v-bind:style="styleOption">
                {{ info.promotion_type == 'main' ? 'รายการส่งเสริมการขายหลัก' : 'รายการส่งเสริมการขายเสริม'}}
              </td>
            </tr>
            <tr>
              <td colspan="2">ระยะเวลา</td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                วันเริ่มต้นการเสนอขาย: 
              </td>
              <td v-bind:style="styleOption">
                {{info.start_sale_date != null ? moment(info.start_sale_date).add(543, 'Y').format('DD-MM-YYYY') : '-'}}
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                วันสิ้นสุดการเสนอขาย:
              </td>
              <td v-bind:style="styleOption">
                {{info.end_sale_date != null ? moment(info.end_sale_date).add(543, 'Y').format('DD-MM-YYYY') : '-'}}
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                วันเริ่มต้นการให้บริการ:
              </td>
              <td v-bind:style="styleOption">
                {{info.start_service_date != null ? moment(info.start_service_date).add(543, 'Y').format('DD-MM-YYYY') : '-'}}
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                วันสิ้นสุดการให้บริการ: <br/>
              </td>
              <td v-bind:style="styleOption">
                {{info.end_service_date != null ? moment(info.end_service_date).add(543, 'Y').format('DD-MM-YYYY') : '-'}} <br/>
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                ค่าบริการเหมาจ่ายรวมตามสิทธิการใช้งาน : 
              </td>
              <td v-bind:style="styleOption">
                {{ info.promotion_price }} บาท
              </td>
            </tr>
            <tr>
              <td colspan="2">
                สิทธิการใช้งานที่ผู้ใช้บริการได้รับจำแนกตามประเภทบริการ
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                ความเร็วดาวน์โหลด :
              </td>
              <td v-bind:style="styleOption">
                {{ info.download_speed }} Mbps
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                ความเร็วอัปโหลด :
              </td>
              <td v-bind:style="styleOption">
                {{ info.upload_speed }} Mbps
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                อัตราค่าบริการต่อหน่วย :
              </td>
              <td v-bind:style="styleOption">
                {{ info.bscpu_internet_per_Mbps ? Math.round(info.bscpu_internet_per_Mbps * 1000)/1000 + ' บาท/Mbps' : '-' }}
              </td>
            </tr>
            <tr>
              <td colspan="2">การให้บริการเสริม</td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                บริการความบันเทิง : 
              </td>
              <td v-bind:style="styleOption">
                {{ info.content_service_th ? info.content_service_th : '-' }}
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                บริการโทรศัพท์เคลื่อนที่ : 
              </td>
              <td v-bind:style="styleOption">
                {{ info.mobile_service_th ? info.mobile_service_th : '-' }}
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                บริการ WiFi/Hotspot : 
              </td>
              <td v-bind:style="styleOption">
                {{ info.wifi_service_th ? info.wifi_service_th : '-' }}
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                บริการ Fixed Line : 
              </td>
              <td v-bind:style="styleOption">
                {{ info.fixed_line_service_th ? info.fixed_line_service_th : '-' }}
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                อุปกรณ์อื่นๆ : 
              </td>
              <td v-bind:style="styleOption">
                {{ info.device_service_th ? info.device_service_th : '-' }}
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                การให้บริการอื่นๆ : 
              </td>
              <td v-bind:style="styleOption">
                {{ info.privilege_other_th ? info.privilege_other_th : '-' }}
              </td>
            </tr>
            <tr>
              <td colspan="2">สิทธิพิเศษ</td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                บริการความบันเทิง : 
              </td>
              <td v-bind:style="styleOption">
                {{ info.privilege_content_th ? info.privilege_content_th : '-' }}
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                บริการโทรศัพท์เคลื่อนที่ : 
              </td>
              <td v-bind:style="styleOption">
                {{ info.privilege_mobile_th ? info.privilege_mobile_th : '-' }}
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                บริการ WiFi/Hotspot : 
              </td>
              <td v-bind:style="styleOption">
                {{ info.privilege_wifi_th ? info.privilege_wifi_th : '-' }}
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                บริการพรีเมียม : 
              </td>
              <td v-bind:style="styleOption">
                {{ info.privilege_premium_th ? info.privilege_premium_th : '-' }}
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                อุปกรณ์อื่นๆ : 
              </td>
              <td v-bind:style="styleOption">
                {{ info.privilege_device_th ? info.privilege_device_th : '-' }}
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                การให้บริการอื่นๆ : 
              </td>
              <td v-bind:style="styleOption">
                {{ info.privilege_other_th ? info.privilege_other_th : '-' }}
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                เงื่อนไขอื่นๆ / ข้อกำหนด ของการใช้บริการ : 
              </td>
              <td v-bind:style="styleOption">
                {{ info.promotion_condition_th ? info.promotion_condition_th : '-' }}
              </td>
            </tr>
            <tr>
              <td v-bind:style="styleOption">
                ลิงก์เว็บไซต์ หรือ ลิงก์รายการส่งเสริมการขาย : 
              </td>
              <td v-bind:style="styleOption">
                {{ info.promotion_link_url ? info.promotion_link_url : '-' }}
              </td>
            </tr>
          </table>
        </template>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  data() {
    return {
      labelPosition: "top",
      show: false,
      month: [],
      styleOption: {
        textAlign: 'left',
        width: '50%',
        verticalAlign: 'top'
      },
      styleCaption: {
        textAlign: 'center',
        fontSize: '16px',
        fontWeight: 'bold'
      }
    };
  },
  watch: {
    dialog() {
      this.show = this.dialog;
    }
  },
  props: ["info", "dialog", "service_type", "rowInfo"],
  methods: {
    handleClose(done) {
      this.$emit("checkModal", false);
      done();
    }
  }
};
</script>
 